import { useFormContext } from 'react-hook-form';
import styles from './EpSwitch.module.scss';
import { useTranslationStore } from '@/stores';
import { useTranslation as t } from '../../../../hooks/useTranslation';

interface EpSwitchProps {
  switchName: string;
  switchLabel: string;
  switchRequired?: boolean;
  onChange?: () => void;
  className?: string;
  disabled?: boolean
}

export const EpSwitch = ({
  switchName,
  switchLabel,
  switchRequired = false,
  onChange,
  className = '',
  disabled = false
}: EpSwitchProps) => {
  const { register } = useFormContext();
  const { translations } = useTranslationStore();

  return (
    <div className={`${styles['ep-switch']} ${className}`}>
      <div className={styles['switch-box']} onChange={onChange}>
        <label className={styles['switch']}>
          <input
            type="checkbox"
            disabled={disabled}
            {...register(`${switchName}` as const, {
              required: {
                value: switchRequired,
                message: t(translations['global'], '* Required Fied'),
              },
            })}
          />

          <span className={styles['slider']}></span>
        </label>
      </div>
      <p>{switchLabel}</p>
    </div>
  );
};
